/**
 * Central registry mapping each `Meter` to its content bundle.
 *
 * Step components import from this module (never from individual meter
 * files) so that adding a new meter is a one-line change here.
 *
 * Atomic file architecture:
 *   - Individual meter content lives in `<meter>-content.ts` sibling
 *     files. Each is edited independently by its content author, avoiding
 *     merge conflicts.
 *   - This registry is the only file that touches all four meters, so
 *     the surface area for cross-meter conflicts is one line per meter.
 */

import { ASSETS_OBJECTS_CONTENT } from './assets-objects-content';
import { AUTOMATIONS_CONTENT } from './automations-content';
import { CS_RESOLUTIONS_CONTENT } from './cs-resolutions-content';
import { ROVO_CREDITS_CONTENT } from './rovo-credits-content';

import type { MeterContent } from './meter-content.types';
import type { Meter } from '../context/types';

export const METER_CONTENT: Record<Meter, MeterContent> = {
	rovoCredits: ROVO_CREDITS_CONTENT,
	automations: AUTOMATIONS_CONTENT,
	csResolutions: CS_RESOLUTIONS_CONTENT,
	assetsObjects: ASSETS_OBJECTS_CONTENT,
};
